import React from 'react'

const CouponBox = () => {
  return (
    <div className='p-2 border border-gray-200'>
      <div className='flex items-center  justify-between '>
          <h1 className='font-bold text-lg '>Apply Coupon</h1>
          <h2 className='text-sm text-rose-500'><button className='font-semibold'>View All</button> </h2>
      </div>
      <div className='mt-3 py-2'>
      <div className="relative mb-3">
    <input type="text" id="floating_outlined" className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-sm border border-gray-400 appearance-none  focus:outline-none focus:ring-0 focus:border-rose-500 peer" placeholder=" " />
    <label for="floating_outlined" className="font-semibold absolute text-sm text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white  px-2 peer-focus:px-2 peer-focus:text-rose-500  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Enter coupon code</label>
</div>
<button className='border text-sm font-semibold bg-white hover:bg-rose-500 hover:text-white border-rose-400 transition-colors duration-100  text-rose-500 px-8 py-1  rounded-sm '> APPLY </button>
      </div>
    </div>
  )
}

export default CouponBox